<template>
    <div>
        <div class="sm:gap-4 sm:items-center sm:pt-1" :class="!ignoreGrid ? 'sm:grid sm:grid-cols-3': ''">
          <label :for="id" class="block text-sm font-medium text-gray-700 sm:mt-px">
            {{label}}
          </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            <div class="max-w-lg sm:max-w-xs flex mt-1">
              <select ref="sel" :id="id" name="sel" class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" @change.prevent="selectChanged">
                  <option v-bind:disabled="!defaultOption" v-bind:hidden="!defaultOption" value  :selected="!modelValue || modelValue == 0">{{defaultOption}}</option>
                  <option v-for="(option, idx) in options" :key="idx" :value="option.id" :selected="modelValue == option.id">{{option.name}}</option>
              </select>
              <slot/>
            </div>

              <div v-if="error" class="max-w-lg sm:max-w-xs">
                <p v-if="!isMultiError" class="mt-2 text-sm text-red-600" :id="id+'-error'">{{error}}</p>
                <div v-if="isMultiError">
                  <p v-for="cerror, idx in error" :key="idx" class="mt-2 text-sm text-red-600" :id="id+'-error'">{{cerror}}</p>
                </div>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
//import { ExclamationCircleIcon } from '@heroicons/vue/solid';

export default {
    components: {
//      ExclamationCircleIcon
    },
    computed: {
      hasSlot: function() {
        return this.$slots.default;
      },
      isMultiError: function() {
        return this.error && Array.isArray(this.error)
      }
    },
    props: [
        'id',
        'label',
        'error',
        'type',
        'placeholder',
        'modelValue',
        'pre',
        'readonly',
        'small',
        'options',
        'defaultOption',
        'ignoreGrid'
    ],
    methods: {
        selectChanged: function() { 
            this.$emit('update:modelValue', this.$refs.sel.value)
        }
    }
};
</script>